import {MemberPageState} from '../types/state'

export const getNoUpcomingEventsUrl = (state: MemberPageState) => state.navigation.noUpcomingEventsLinkPageUrl
export const getNoUpcomingEventsPageId = (state: MemberPageState) => state.navigation.noUpcomingEventsLinkPageId
